import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Nombrar la voz",
    opening: localizedGenderNode(
      [
      "Hoy noto la voz que juzga.",
      "No soy esa voz.",
      "Estoy aquí."
    ],
      [
      "Hoy noto la voz que juzga.",
      "No soy esa voz.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo aparece esta voz?",
      "¿Qué palabras usa?",
      "¿Qué siento después?"
    ],
      [
      "¿Cuándo aparece esta voz?",
      "¿Qué palabras usa?",
      "¿Qué siento después?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una voz es una voz, no soy yo."
    ],
      [
      "Una voz es una voz, no soy yo."
    ]
    ),
    action: localizedGenderNode(
      "escribir una frase - \"Es una voz, no la verdad\".",
      "escribir una frase - \"Es una voz, no la verdad\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El momento que activa",
    opening: localizedGenderNode(
      [
      "Hoy noto el momento en que se enciende el juicio.",
      "Solo verlo.",
      "Me quedo conmigo."
    ],
      [
      "Hoy noto el momento en que se enciende el juicio.",
      "Solo verlo.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ],
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué pasó justo antes de que empezara la voz?",
      "¿Qué dice la voz entonces?",
      "¿Dónde se siente en el cuerpo?"
    ],
      [
      "¿Qué pasó justo antes de que empezara la voz?",
      "¿Qué dice la voz entonces?",
      "¿Dónde se siente en el cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "En el primer momento hay un pequeño espacio."
    ],
      [
      "En el primer momento hay un pequeño espacio."
    ]
    ),
    action: localizedGenderNode(
      "una respiración cuando sube la voz.",
      "una respiración cuando sube la voz."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "El cuerpo bajo juicio",
    opening: localizedGenderNode(
      [
      "Hoy escucho mi cuerpo cuando sube el juicio.",
      "No para arreglarlo.",
      "Estoy aquí."
    ],
      [
      "Hoy escucho mi cuerpo cuando sube el juicio.",
      "No para arreglarlo.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi respiración.",
      "Una respiración."
    ],
      [
      "Noto mi respiración.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde sostiene el cuerpo el juicio?",
      "¿Qué necesita mi cuerpo en ese momento?",
      "¿Qué podría suavizarse un poco?"
    ],
      [
      "¿Dónde sostiene el cuerpo el juicio?",
      "¿Qué necesita mi cuerpo en ese momento?",
      "¿Qué podría suavizarse un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El cuerpo no es culpable, solo sostiene."
    ],
      [
      "El cuerpo no es culpable, solo sostiene."
    ]
    ),
    action: localizedGenderNode(
      "una mano en el pecho y una respiración.",
      "una mano en el pecho y una respiración."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Historia vs. hecho",
    opening: localizedGenderNode(
      [
      "Hoy separo hecho de historia.",
      "Sin pelearlo.",
      "Me quedo conmigo."
    ],
      [
      "Hoy separo hecho de historia.",
      "Sin pelearlo.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ],
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es el hecho simple aquí?",
      "¿Qué historia saltó?",
      "¿Qué posibilidad más suave también podría ser cierta?"
    ],
      [
      "¿Cuál es el hecho simple aquí?",
      "¿Qué historia saltó?",
      "¿Qué posibilidad más suave también podría ser cierta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una historia no soy yo."
    ],
      [
      "Una historia no soy yo."
    ]
    ),
    action: localizedGenderNode(
      "una frase interna - \"Esto es interpretación\".",
      "una frase interna - \"Esto es interpretación\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Lo que la voz intenta hacer",
    opening: localizedGenderNode(
      [
      "Hoy reviso lo que la voz intenta lograr.",
      "Sin justificarla.",
      "Estoy aquí."
    ],
      [
      "Hoy reviso lo que la voz intenta lograr.",
      "Sin justificarla.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Ablando un poco los hombros.",
      "Una respiración."
    ],
      [
      "Ablando un poco los hombros.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿De qué intenta protegerme la voz?",
      "¿De qué tiene miedo?",
      "¿Qué precio estoy pagando?"
    ],
      [
      "¿De qué intenta protegerme la voz?",
      "¿De qué tiene miedo?",
      "¿Qué precio estoy pagando?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Si intenta proteger, también puedo ver el costo."
    ],
      [
      "Si intenta proteger, también puedo ver el costo."
    ]
    ),
    action: localizedGenderNode(
      "una frase de comprensión.",
      "una frase de comprensión."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Una voz antigua",
    opening: localizedGenderNode(
      [
      "Hoy reviso si esta es una voz antigua.",
      "No para profundizar.",
      "Estoy aquí."
    ],
      [
      "Hoy reviso si esta es una voz antigua.",
      "No para profundizar.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mis pies.",
      "Una respiración."
    ],
      [
      "Noto mis pies.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿A quién se parece esta voz?",
      "¿Cuándo la escuché antes?",
      "¿Qué necesitaba entonces?"
    ],
      [
      "¿A quién se parece esta voz?",
      "¿Cuándo la escuché antes?",
      "¿Qué necesitaba entonces?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Si es una voz antigua, puedo sostenerla con suavidad."
    ],
      [
      "Si es una voz antigua, puedo sostenerla con suavidad."
    ]
    ),
    action: localizedGenderNode(
      "decir en mi corazón \"Esta es una voz antigua\" una vez.",
      "decir en mi corazón \"Esta es una voz antigua\" una vez."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "El costo",
    opening: localizedGenderNode(
      [
      "Hoy veo el costo del juicio.",
      "Sin castigo.",
      "Me quedo conmigo."
    ],
      [
      "Hoy veo el costo del juicio.",
      "Sin castigo.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento mi forma de sentarme.",
      "Una respiración."
    ],
      [
      "Siento mi forma de sentarme.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me quita este juicio?",
      "¿Qué parte de mí se hace más pequeña?",
      "¿Qué me gustaría devolverme?"
    ],
      [
      "¿Qué me quita este juicio?",
      "¿Qué parte de mí se hace más pequeña?",
      "¿Qué me gustaría devolverme?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Ver el costo es un paso de compasión."
    ],
      [
      "Ver el costo es un paso de compasión."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra sobre lo que me devuelvo.",
      "escribir una palabra sobre lo que me devuelvo."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Una pequeña compasión",
    opening: localizedGenderNode(
      [
      "Hoy intento hablarme con suavidad.",
      "No perfecto, solo un poco.",
      "Estoy aquí."
    ],
      [
      "Hoy intento hablarme con suavidad.",
      "No perfecto, solo un poco.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Suavizo la mandíbula.",
      "Una respiración."
    ],
      [
      "Suavizo la mandíbula.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo le hablaría a un amigo aquí?",
      "¿Qué frase suave necesito escuchar?",
      "¿Qué cambia en mí cuando la escucho?"
    ],
      [
      "¿Cómo le hablaría a un amigo aquí?",
      "¿Qué frase suave necesito escuchar?",
      "¿Qué cambia en mí cuando la escucho?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una palabra suave puede cambiar el tono."
    ],
      [
      "Una palabra suave puede cambiar el tono."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave para mí.",
      "una frase suave para mí."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Un límite interno",
    opening: localizedGenderNode(
      [
      "Hoy pongo un límite a la voz cruel.",
      "En silencio.",
      "Estoy aquí."
    ],
      [
      "Hoy pongo un límite a la voz cruel.",
      "En silencio.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento la espalda apoyada.",
      "Una respiración."
    ],
      [
      "Siento la espalda apoyada.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué frases son demasiado para mí?",
      "¿Qué límite quiero poner?",
      "¿Cómo me lo digo?"
    ],
      [
      "¿Qué frases son demasiado para mí?",
      "¿Qué límite quiero poner?",
      "¿Cómo me lo digo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un límite interno es protección, no guerra."
    ],
      [
      "Un límite interno es protección, no guerra."
    ]
    ),
    action: localizedGenderNode(
      "decir \"No me hablo así\".",
      "decir \"No me hablo así\"."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una petición para mí",
    opening: localizedGenderNode(
      [
      "Hoy me doy una petición clara.",
      "Sin castigo.",
      "Me quedo conmigo."
    ],
      [
      "Hoy me doy una petición clara.",
      "Sin castigo.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro lento.",
      "Una respiración."
    ],
      [
      "Respiro lento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es mi petición más importante ahora?",
      "¿Cómo decirla en una sola frase?",
      "¿Qué estoy dispuesto/a a darme a cambio?"
    ],
      [
      "¿Cuál es mi petición más importante ahora?",
      "¿Cómo decirla en una sola frase?",
      "¿Qué estoy dispuesto/a a darme a cambio?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición puede suavizar el día."
    ],
      [
      "Una petición puede suavizar el día."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase corta.",
      "escribir la petición en una frase corta."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Una frase nueva",
    opening: localizedGenderNode(
      [
      "Hoy elijo una frase nueva para mí.",
      "Pequeña y simple.",
      "Estoy aquí."
    ],
      [
      "Hoy elijo una frase nueva para mí.",
      "Pequeña y simple.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi voz interna.",
      "Una respiración."
    ],
      [
      "Noto mi voz interna.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué frase nueva quiero decirme?",
      "¿Cuándo más necesitaba escucharla?",
      "¿Cómo se siente cuando la digo?"
    ],
      [
      "¿Qué frase nueva quiero decirme?",
      "¿Cuándo más necesitaba escucharla?",
      "¿Cómo se siente cuando la digo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una frase nueva crea un pequeño espacio."
    ],
      [
      "Una frase nueva crea un pequeño espacio."
    ]
    ),
    action: localizedGenderNode(
      "decir la frase una vez.",
      "decir la frase una vez."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Reparar después de una caída",
    opening: localizedGenderNode(
      [
      "Hoy aprendo a volver a mí después de una caída.",
      "Sin castigo.",
      "Estoy aquí."
    ],
      [
      "Hoy aprendo a volver a mí después de una caída.",
      "Sin castigo.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo vuelve la voz después de un error?",
      "¿Qué me ayuda a volver a mí?",
      "¿Qué frase de reparación quiero decir?"
    ],
      [
      "¿Cuándo vuelve la voz después de un error?",
      "¿Qué me ayuda a volver a mí?",
      "¿Qué frase de reparación quiero decir?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Reparar es un regreso suave, no un borrado."
    ],
      [
      "Reparar es un regreso suave, no un borrado."
    ]
    ),
    action: localizedGenderNode(
      "una frase corta de reparación.",
      "una frase corta de reparación."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Una pequeña práctica",
    opening: localizedGenderNode(
      [
      "Hoy elijo una práctica pequeña y constante.",
      "No grande.",
      "Estoy aquí."
    ],
      [
      "Hoy elijo una práctica pequeña y constante.",
      "No grande.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento mi forma de sentarme.",
      "Una respiración."
    ],
      [
      "Siento mi forma de sentarme.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué práctica pequeña me ayudará a sostenerme?",
      "¿Cuándo en el día puedo hacerlo?",
      "¿Qué me recordará suavemente?"
    ],
      [
      "¿Qué práctica pequeña me ayudará a sostenerme?",
      "¿Cuándo en el día puedo hacerlo?",
      "¿Qué me recordará suavemente?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una práctica pequeña construye una voz nueva."
    ],
      [
      "Una práctica pequeña construye una voz nueva."
    ]
    ),
    action: localizedGenderNode(
      "elegir un momento para la práctica.",
      "elegir un momento para la práctica."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave",
    opening: localizedGenderNode(
      [
      "Hoy cierro el viaje con suavidad.",
      "Sin forzar un final perfecto.",
      "Estoy aquí."
    ],
      [
      "Hoy cierro el viaje con suavidad.",
      "Sin forzar un final perfecto.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre esta voz?",
      "¿Cuál es la señal temprana de que vuelve?",
      "Frase de regreso para el momento antes - ¿qué me digo?"
    ],
      [
      "¿Qué aprendí sobre esta voz?",
      "¿Cuál es la señal temprana de que vuelve?",
      "Frase de regreso para el momento antes - ¿qué me digo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo ser preciso/a sin crueldad."
    ],
      [
      "Puedo ser preciso/a sin crueldad."
    ]
    ),
    action: localizedGenderNode(
      "una respiración antes de responder.",
      "una respiración antes de responder."
    ),
  },
].map(buildNormalizedDay);

export const cruelSelfJudgmentBlueprintEs = buildNormalizedPilotBlueprint({
  id: "cruel_self_judgment_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "cruel_self_judgment",
  category: "self_worth",
  journeyName: {
    he: "שיפוט עצמי אכזרי (איך שוב עשיתי את זה)",
    en: "Cruel self-judgment (How did I do it again)",
    es: "Juicio propio cruel (¿Cómo lo hice otra vez?)",
  },
  days,
});

export default cruelSelfJudgmentBlueprintEs;
